import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI202_2 = ({ hide }) => {
  const questionData = [
    {
      fieldName: "percentageSeniorManagementLocalHires",
      title:
        "a. What percentage of senior management positions at significant locations of operation are filled by individuals hired from the local community?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "seniorManagementDefinition",
      title:
        "b. How does your organization define 'senior management' positions?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "geographicalHiring",
      title:
        "c. How does your organization define the term 'local' in the context of geographical hiring practices?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "significantLocationsDefinition",
      title:
        "d. Could you provide the definition your organization uses for identifying 'significant locations of operation'?",
      type: "text",
      placeholder: "Enter Text",
    },
  ];

  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 =
        res?.data?.data?.GRI200?.seniorManagementLocalHiresProportion;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      percentageSeniorManagementLocalHires:
        data?.percentageSeniorManagementLocalHires || "",
      seniorManagementDefinition: data?.seniorManagementDefinition || "",
      geographicalHiring: data?.geographicalHiring || "",
      significantLocationsDefinition:
        data?.significantLocationsDefinition || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "distance" && !validateNumber(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let transformedData2 = {
        seniorManagementLocalHiresProportion: formData,
        type: "GRI200",
        submitted202_2: true,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/203-1/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/203-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading}>202 : Market Presence 2016</p>}
      <p className={styles.main_heading}>
        202-2 : Proportion of senior management hired from the local community
      </p>
      {/* a */}
      {questionData.map((el) => (
          <Box sx={{ mt: hide ? "-1.5rem" : "1rem" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <p
              className={styles.ques_heading}
              style={{ textIndent: "-1rem", }}
            >
              {el.title}
            </p>
          </Box>
          <Box sx={{ ml: 2.3 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI202_2;
